import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-common-message-modal',
  templateUrl: './common-message-modal.component.html',
  styleUrls: ['./common-message-modal.component.css']
})
export class CommonMessageModalComponent implements OnInit,AfterViewInit {
@Input('successMessage') successMessage;
@Input('isFollowUp') isFollowUp;
@Output() showNotification = new EventEmitter();
@Output() isFollowUpSubmit = new EventEmitter();

@Input('isActionSubmit') isActionSubmit;
@Output() isActionSubmitModal = new EventEmitter();

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    // this.successMessage = this.successMessage[0]?.Message ? this.successMessage[0]?.Message.replace(/[\<\>]/g, '"') : this.successMessage.replace(/[\<\>]/g, '"');

    console.log(this.isFollowUp);
    console.log(this.isActionSubmit);

    console.log(this.successMessage);

  }

  closeModalFun(){
    this.showNotification.emit(false)
  }

  // isFollowUpSubmit
  followUpSubmit(event){
    this.isFollowUpSubmit.emit(event);
  }

  // popup close on click outside
  hidePopup(){
    if(this.isFollowUp) return
    this.showNotification.emit(false);
  }

  // isActionSubmitModal
  actionSubmitModal(event){
    console.log(event);
    this.isActionSubmitModal.emit(event);
  }

  ngAfterViewInit() {
    // Set focus to the modal title after the view has initialized
    const modalTitle = this.el.nativeElement.querySelector('#LogoutModal button');
    if (modalTitle) {
      modalTitle.focus();
    }
  }

  setMessage(message){
    if(message.includes('<b>')){
      return message
    } else {
      return message.replace(/[\<\>]/g, "'");
    }
  }
}
